import {Component, Input, OnInit} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { ToasterService } from '../../_services/toaster.service';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthenicationService} from '../../_services/authenication.service';
import {ScheduleService} from "../../_services/schedule.service";

declare var jQuery: any;
import * as $ from 'jquery';
import * as moment from 'moment';
import 'fullcalendar';
import {Ng4LoadingSpinnerService} from "ng4-loading-spinner";

@Component({
  selector: 'app-schedule-test',
  templateUrl: './schedule-test.component.html',
  styleUrls: ['./schedule-test.component.css']
})
export class ScheduleTestComponent implements OnInit {
  @Input() eventData: any;
  defaultConfigurations: any;

  addScheduleForm: FormGroup;
  submitted = false;

  day: string;
  date: string;
  start_time: string;
  end_time: string;
  getdaDte: string;

  @Input()
  set configurations(config: any) {
    if(config) {
      this.defaultConfigurations = config;
    }
  }

  id: string = this.route.snapshot.params['id'];


  constructor(private formBuilder: FormBuilder, private router: Router, private route: ActivatedRoute, private toaster: ToasterService, private authenicationService: AuthenicationService, private scheduleservice: ScheduleService,private spinnerService: Ng4LoadingSpinnerService) { }

  ngOnInit() {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;

    this.getDoctorSchedules(this.id);
    this.route.queryParams.subscribe(params => {
      this.getdaDte = params['date'];
    });


    this.addScheduleForm = this.formBuilder.group({
      location: ['', [Validators.required]],
      scheduleFor: ['All', [Validators.required]],
      status: ['true', [Validators.required]],
    });

   let lastdate = moment(new Date()).add(1, 'weeks').endOf('isoWeek').format('YYYY-MM-DD');


  }


  dayClick(info) {
    let tzDifference = info._d.getTimezoneOffset();
    let offsetTime = new Date(info._d.getTime() + tzDifference * 60 * 1000); //this will calculate time in point of view local time and set date
    let date = moment(offsetTime).format('YYYY-MM-DD');
    let start_time = moment(offsetTime).format('HH:mm');
    let myDate = moment(offsetTime).format('YYYY-MM-DD HH:mm:ss');
    let end_time = moment(myDate).add(1, 'hours').format('HH:mm');
    let day = moment(date).format('ddd');

    if (end_time == 'Invalid date'){
      let t = start_time.split(' ')[0];
      let t1 = t.split(':')[0];
      let t2 = parseInt(t1)+1;
      end_time = t2.toString()+":00";
      //console.log(end_date);
    }
   // console.log(day);
    this.day = day;
    this.date = date;
    this.start_time  = start_time;
    this.end_time  = end_time;
    jQuery('#addSchedule').modal('show');



  }

  changeParam(payload){
    this.getDoctorSchedules(payload);
  }

  onSubmit(){

    this.submitted = true;
    //this.spinnerService.show();
    // stop here if form is invalid
    if (this.addScheduleForm.invalid) {
      //this.spinnerService.hide();
      return;
    }

    const payload = {
      docid: this.id,
      day: this.day,
      date: this.date,
      start_time: this.start_time,
      end_time: this.end_time,
      location: this.addScheduleForm.controls.location.value,
      scheduleFor: this.addScheduleForm.controls.scheduleFor.value,
      status: this.addScheduleForm.controls.status.value,
      timezone:  Intl.DateTimeFormat().resolvedOptions().timeZone,
      time_offset: new Date().getTimezoneOffset()
    };
    this.addEvent(payload,this.date);
  }

  get f() { return this.addScheduleForm.controls; }

  addEvent(payload,date) {
    this.scheduleservice.createMultiSchedule(payload)
      .subscribe(
        (data: any) => {
          if (data && data.ResponseCode === '200') {
            jQuery('#addSchedule').modal('hide');
           this.router.navigate([`/schedule-test/${this.id}`],{ queryParams: { date: date } });

          } else {
            this.toaster.showError('Add Schedule', data.ResponseMessage);
            //this.spinnerService.hide();
          }
          // this.router.navigate([this.returnUrl]);
        },
        error => {
          this.toaster.showError('Add Schedule', error.error.ResponseMessage);
          //this.spinnerService.hide();
        });
  }

  deleteSchedule(id,date) {
    const payload = {id: id};
    this.scheduleservice.deleteSchedule(payload)
      .subscribe(
        (data: any) => {
          if (data && data.ResponseCode === '200') {
            jQuery('#addSchedule').modal('hide');
           this.router.navigate([`/schedule-test/${this.id}`],{ queryParams: { date: date }});
            // this.route.params.subscribe(routeParams => {
            //   this.changeParam(routeParams.id);
            // });

            //location.reload();
          } else {
            this.toaster.showError('Schedule List', data.ResponseMessage);
          }
        },
        error => {
          this.toaster.showError('Schedule List', error.error.ResponseMessage);
        });
  }


  getDoctorSchedules(id) {
    this.scheduleservice.getDoctorEvents(id)
      .subscribe(
        (data: any) => {
          if (data && data.ResponseCode === '200') {
            this.eventData = data.avilibility;
            //console.log(data.avilibility);
            this.route.params.subscribe(routeParams => {
              this.addDefaultConfifurations(this.eventData,this.getdaDte);
              $('#full-calendar').fullCalendar(
                this.defaultConfigurations
              );
            });


          }
        });
  }

  ClickOrSelect(){

  }

  addDefaultConfifurations(events,date){

    this.defaultConfigurations = {
      editable: false,
      eventLimit: true,
      titleFormat: 'MMM D YYYY',
      minTime: '7:00',
      maxTime: '22:00',
      header: {
        left: 'prev,next today',
        center: 'title',
        right: 'month,agendaWeek,agendaDay'
      },
      defaultView: 'agendaWeek',
      buttonText: {
        today: 'Today',
        month: 'Month',
        week: 'Week',
        day: 'Day'
      },
      views: {
        agenda: {
          eventLimit: 7
        }
      },
      allDaySlot: false,
      ignoreTimezone: false,
      defaultDate: moment(date),
      timezone:'Asia/Kolkata',
      slotDuration: moment.duration('00:10:00'),
      slotLabelInterval: moment.duration('00:20:00'),
      firstDay: 1,
      selectable: {
        month: false,
        agenda: true
      },
     // selectHelper: true,
      events: events,

      // dayClick: (info) => {
      //   // this.datainfo = info;
      //
      //   this.dayClick(info);
      // },
      eventClick: (info) => {

        if (info.status == true){
          let date = moment(info.start).format('YYYY-MM-DD');
          this.deleteSchedule(info._id,date)
        }
        else{
          this.toaster.showError('Schedule','Cannot delete booked schedule');
        }
      },

      select: (start, end) => {
        let date = moment(start).format('YYYY-MM-DD');
        let day = moment(start).format('ddd');
        let start_time = moment(start).format('HH:mm');
        let end_time = moment(end).format('HH:mm');
        let start_time_for_diff = moment(start).format('YYYY-MM-DD HH:mm:ss');
        let end_time_for_diff = moment(end).format('YYYY-MM-DD HH:mm:ss');

        const differenceInMinutes = moment(end_time_for_diff).diff(start_time_for_diff, 'minutes');
        if (differenceInMinutes < 60){
           end_time = moment(start_time_for_diff).add(1, 'hours').format('HH:mm');
        }
        if (differenceInMinutes > 60){
          end_time = moment(end_time_for_diff).add(30, 'minutes').format('HH:mm');
        }

        let timeStops = this.getTimeStops(start_time, end_time);
       // console.log(timeStops);
        let start_array = [];
        let end_array = [];

        let i;
        for (i = 0; i <= timeStops.length; i = i + 1) {
          if (timeStops[i] !== undefined && timeStops[i+1] !== undefined) {
              start_array.push(timeStops[i]);
              end_array.push(timeStops[i + 1]);
          }
        }

        this.day = day;
        this.date = date;
        this.start_time  = start_array.toString();
        this.end_time  = end_array.toString();
        jQuery('#addSchedule').modal('show');
      }

    };
  }


  getTimeStops(start, end){
    let startTime = moment(start, 'HH:mm');
    let endTime = moment(end, 'HH:mm');

    if( endTime.isBefore(startTime) ){
      endTime.add(1, 'day');
    }

    let timeStops = [];

    while(startTime <= endTime){
      timeStops.push(moment(startTime).format('HH:mm'));
      startTime.add(1, 'hours');
    }
    return timeStops;
  }

}
